import gql from 'graphql-tag'

export const QUERY_GET_SOCIAL_MEDIA = gql`
  query SocialMedia {
    socialMedia {
      facebook
      instagram
      whatsapp {
        number
        message
        units
        show_in_hotsite
      }
      youtube
      linkedin
      twitter
      tiktok
    }
  }
`
export const MUTATION_SOCIAL_MEDIA = gql`
  mutation UpsertSocialMedia($socialMedia: SocialMediaInput!) {
    upsertSocialMedia(input: $socialMedia) {
      message
    }
  }
`
